// extracted by mini-css-extract-plugin
module.exports = {"root":"Previews-module--root--2A26s","prev":"Previews-module--prev--22OyM","next":"Previews-module--next--2x81M"};